/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import CreateWorkspaceButton from 'ui/components/CreateWorkspaceButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import CardsList from 'shared/ui/components/Cardslist.vue';
import WorkspacesList from 'ui/components/WorkspacesList.vue';

import { isEmpty } from 'lodash';

// Mixins
import templateFetcher from 'ui/mixins/webinars/templates-fetcher';

const __vue_script__ = {
    name: 'WebinarTemplates',

    components: {
        CreateWorkspaceButton,
        SearchBar,
        CardsList,
        WorkspacesList
    },

    mixins: [templateFetcher],

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        const user = this.$services.user.getCurrentUser();
        const canCreate = user.orgs
            .some(org =>
                this.$services.user.hasPermission('templates.create_new', {
                    org_id: org._id
                }));

        return {
            canCreate,
            templates: [],
            noTemplateImage: this.$utils.assets.imagePath('workspace-start.svg'),
            error: null,
            viewTemplates: [],
            gettingStartedUrl: this.$const.KB_TEMPLATE_LEARN_MORE,
            resetListener: () => this.reset(),
            loading: true,
            searchTerm: ''
        };
    },

    computed: {
        noResults() {
            return (
                this.searchTerm.length > 0 &&
                this.viewTemplates.length === 0
            );
        },

        noDataAfterLoading() {
            return (
                this.searchTerm.length === 0 &&
                this.viewTemplates.length === 0 &&
                !this.loading
            );
        }
    },

    watch: {
        searchTerm() {
            this.filterSearch();
        }
    },

    async created() {
        this.$services.webinar.addEventListener('webinarTemplateCreated', this.resetListener);

        this.reset();
    },

    destroyed() {
        this.$services.webinar.removeEventListener('webinarTemplateCreated', this.resetListener);
    },

    methods: {
        /**
         * Route the user to template view/edit page
         */
        openTemplate(workspace, event) {
            this.$router.push(event.link);
        },

        /**
         * Reset the filtered search result to the inital dataset
         */
        resetSearch() {
            this.viewTemplates = this.templates;
        },

        /**
         * Filter the templates by the search input
         */
        filterSearch() {

            if (isEmpty(this.searchTerm)) this.resetSearch();
            const locale = this.$i18n.locale;
            const searchTerms = this.searchTerm.toLocaleLowerCase(locale).trim().split(' ');
            this.viewTemplates = this.templates.filter(t => {
                const lookupString = (`${t.name}`).toLocaleLowerCase(locale);
                return searchTerms.some(term => lookupString.includes(term));
            });


        },

        async reset() {
            this.loading = true;
            this.templates = await this.getTemplates();

            this.viewTemplates = this.templates;
            this.loading = false;
        },

        /**
         * Resets the search input
         */
        clearSearch() {
            this.searchTerm = '';
            this.resetSearch();
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"inner-page webinar-template-listing",attrs:{"status":_vm.loading}},[(!_vm.error && !_vm.noDataAfterLoading)?_c('section',{staticClass:"page-content templates-page"},[_c('div',{staticClass:"search",class:[ _vm.noResults ? 'no-results' : '']},[(!_vm.loading && _vm.canCreate)?_c('create-workspace-button',{staticClass:"create",attrs:{"modal-classes":"small","modal-props":_vm.params,"button-key":"templates.create_template","modal-type":"webinar_template"}}):_vm._e(),_c('search-bar',{attrs:{"results":!_vm.noResults},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1),_c('div',{staticClass:"section-list"},[_c('workspaces-list',{attrs:{"mode":"WebinarTemplate","workspaces":_vm.viewTemplates},on:{"click":_vm.openTemplate}})],1)]):_vm._e(),(_vm.error)?_c('div',{staticClass:"alert alert-error"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))]),_c('p',[_vm._v(_vm._s(_vm.error))])]):_vm._e(),(_vm.noDataAfterLoading)?_c('div',{staticClass:"no-data"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.noTemplateImage),expression:"noTemplateImage"}],attrs:{"silent":false}}),_c('h1',{staticClass:"welcome"},[_vm._v(_vm._s(_vm.$t('templates.welcome')))]),(!_vm.canCreate)?_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t("templates.no_templates")))]):_vm._e(),(_vm.canCreate)?_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t("templates.no_templates_admin")))]):_vm._e(),(_vm.canCreate)?_c('create-workspace-button',{staticClass:"create",attrs:{"modal-classes":"medium","modal-props":_vm.params,"button-key":"templates.create_template","modal-type":"webinar_template"}}):_vm._e(),_c('br'),_c('a',{attrs:{"href":_vm.gettingStartedUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('templates.learn_more')))])],1):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WebinarTemplates.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__